import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { AuthService, TipoPortal } from './src/app/services/authService/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const portalEsperado = route.data['portal'] as TipoPortal;
    const portalAtual = this.auth.getPortalLogado();
  
    if (this.auth.isLogado() && portalAtual === portalEsperado) {
      return true;
    }
  
    this.router.navigate(['/']);
    return false;
  }
}
